if (!customElements.get('video-modal-toggle')) {

  class VideoModalToggle extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.addEventListener('click', () => {
        const videoModal = document.querySelector('.js-video-modal');
      
        if (!videoModal) return;
  
        const videoData = JSON.parse(this.querySelector('.js-video-modal-data').innerText);

        document.dispatchEvent(new CustomEvent('videoModal:open', {
          detail: {
            video: videoData.video,
            id: videoData.id
          }
        }))
      });
    }
  }

  customElements.define('video-modal-toggle', VideoModalToggle);
}

if (!customElements.get('video-modal')) {

  class VideoModal extends HTMLElement {
    constructor() {
      super();
      this.currentVideo = null;
      this.init();
    }

    init() {
      this.modalVideo = this.querySelector('.js-video-modal-video');
      this.modalClose = this.querySelector('.js-video-modal-close');
      this.modalPlay = this.querySelector('.js-video-modal-play');

      this.modalClose.addEventListener('click', () => this.close());
      this.modalPlay.addEventListener('click', () => this.play());

      document.addEventListener('videoModal:open', (e) => this.open(e.detail));
    }

    open(data) {
      document.body.classList.add('video-modal-open');

      const video = data.video;
      
      if (this.currentVideo !== data.id) {
        this.modalVideo.innerHTML = video;
      }

      this.currentVideo = data.id;
    }

    close() {
      document.body.classList.remove('video-modal-open');
      const video = this.querySelector('video');
      
      if (video) {
        video.pause();
        video.controls = false;
        this.classList.remove('playing');
      }

      this.classList.remove('playing');
    }

    play() {
      const video = this.querySelector('video');

      if (video) {
        video.play();
        video.controls = true;
        this.classList.add('playing');
      }
    }
  }

  customElements.define('video-modal', VideoModal);
}
